// // custom new js start here  2025

// Open the Rebuy SmartCart drawer when the header cart link is clicked.
// Rebuy injects `window.Rebuy.SmartCart` asynchronously, so we guard against
// it not being ready yet and fall back to the link's default behaviour
// (navigating to /cart) when it isn't.
document.addEventListener('click', function (e) {
  const cartLink = e.target.closest('.cart a, .cart-trigger, .main-nav .cart a');
  if (!cartLink) return;

  if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
    e.preventDefault();
    Rebuy.SmartCart.show();
  }
});

document.addEventListener('rebuy:cart.change', async () => {
  const cart = await fetch('/cart.js').then(r => r.json());
  document.querySelectorAll('.total-item-count').forEach(el => {
    el.textContent = cart.item_count;
  });
});

// $("#phone-nav").click(function () {
//     $("body").toggleClass("navShown");
// });
$(document).on("click", ".benefits__popup-content ul a", function (e) {
  e.preventDefault();

  const $link = $(this);
  const href = $link.attr("href");
  if (!href) {
    console.log("No href found");
    return;
  }

  const cleanText = href.replace(/^#/, "");

  const html = `
    <div class="benefits__popup-source">
      <h6>Source:</h6>
      <p>${cleanText}</p>
      <div class="benefits__popup-source-close" style="cursor:pointer;">
        <img src="https://cdn.shopify.com/s/files/1/0587/9866/9990/files/close.svg?v=1753805999" alt="Close">
      </div>
    </div>
  `;

  $(".benefits__popup-source").remove();
  const originalText = $link.text();

  $link.html(`${originalText} ${html}`);

  $(this).find(".benefits__popup-source").addClass("benefits__popup-source-show");
});

$(document).on("click", ".benefits__popup-source-close", function (e) {
  e.stopPropagation();

  $(this).closest(".benefits__popup-source").remove();
});



$( document ).ready(function() {
    $("form").each(function() {
        var $form = $(this);
        var variantAvailable;

        var $checked = $form.find(".main-product__input:checked");
        if ($checked.length) {
            variantAvailable = $checked.attr("data-varinat-available");
        } else {
            variantAvailable = $form.find(".variant-select option:selected").attr("data-varinat-available");
        }

        if (variantAvailable == 'false') {
            $form.find(".main-product__atc").addClass("disabled");
        } else {
            $form.find(".main-product__atc").removeClass("disabled");
        }
    });
});

$(document).ready(function () {
    $(".review__text p").each(function () {
        var fullText = $(this).text().trim();
        if (fullText.length > 50) {
            var shortText = fullText.substring(0, 50) + "...";
            $(this).data("full", fullText);
            $(this).data("short", shortText);
            $(this).text(shortText);
        }
    });

    $(".review__text").on("click", function () {
        var p = $(this).find("p");
        
        if (p.text() === p.data("short")) {
            // Set short text height
            p.text(p.data("full"));
            
            // Set to auto height smoothly
            var fullHeight = p.css({height: 'auto'}).height(); 
            p.height(p.data("shortHeight"))
             .animate({ height: fullHeight }, 400, function () {
                 p.css("height", "auto");
             });
        } else {
            // Animate back to short text
            p.text(p.data("short"));
            var shortHeight = p.css({height: 'auto'}).height();
            p.height(p.data("fullHeight"))
             .animate({ height: shortHeight }, 400, function () {
                 p.css("height", "auto");
             });
        }
    });

    // Store shortHeight and fullHeight for smooth animation
    $(".review__text p").each(function () {
        var shortText = $(this).data("short");
        var fullText = $(this).data("full");
        
        if (shortText && fullText) {
            // Measure short height
            $(this).text(shortText);
            var shortHeight = $(this).height();
            $(this).data("shortHeight", shortHeight);
            
            // Measure full height
            $(this).text(fullText);
            var fullHeight = $(this).height();
            $(this).data("fullHeight", fullHeight);
            
            // Reset to short text
            $(this).text(shortText);
        }
    });
});





function showModal(event,el){
  event.preventDefault();

    var handle= $(el).attr("data-handle");

   fetch(`/products/${handle}?section_id=product_alternate__info`)
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".quick-buy__inner", cart__html);
      console.log(render__html);
      $(".quick-buy__inner").replaceWith(render__html);
       $("body").addClass('quick-buy-popup-open');
    });
}


function quantityOptionItems(el){
     var text = $(el).html();
    var item_price = $(el).attr('data-price');
    $('.custom-dropdown__stat').html(text);
    $('.variant-select option').attr("selected", false);
    var Varaint_available= $(el).attr("data-varinat-available");
    if(Varaint_available == 'false'){
        $(".quick-buy__addTo").addClass("disabled");
    }
    else{
    $(".quick-buy__addTo").removeClass("disabled");
    }
    $('.variant-select [data-price="' + item_price + '"]').attr("selected", true);
    $('.variant-select').trigger('change'); 
}



function oneTime(el){
    $('.subscriptions__bot').slideUp();
    $(".subscriptions__subscribe").removeClass("active");
    $('.subscriptions__text').addClass('strike-through');
    $(el).addClass("active");
    $('.subscriptions__select').attr('name', '');
    $('.one-time-feeding-guide-btn').slideDown();
}
 
function subscriptionOption(el){
$(".subscriptions__one-time").removeClass("active");
$(el).addClass("active");
    $('.subscriptions__bot').slideDown();
    $('.subscriptions__select').attr('name', 'selling_plan');
    $('.subscriptions__text').removeClass('strike-through');
    $('.one-time-feeding-guide-btn').slideUp();
}





function closeModal(){
   $("body").removeClass('quick-buy-popup-open'); 
}

function AccordionOpenHide(el){
  
    const $this = $(el);

    if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.find('.quick-buy__dropdown-item-content').stop(true, true).slideUp(300);
    } else {
        $('.quick-buy__dropdown-item').removeClass('active');
        $('.quick-buy__dropdown-item-content').stop(true, true).slideUp(300);
        $this.addClass('active');
        $this.find('.quick-buy__dropdown-item-content').stop(true, true).slideDown(300);
    }


}


function changeInputType(el){
    var product_price = $('.main-product__input:checked').attr('data-price');
    var product_sub_price = $('.main-product__input:checked').attr('data-sub-price');
    var product_comp_price = $('.main-product__input:checked').attr('data-comp-price');
    $('.subscriptions__one-time .subscriptions__right').text(product_price);
    $('.sub-price').text(product_sub_price);
    $('.origin-price').text(product_price);

    var Varaint_available= $(el).attr("data-varinat-available");
    if(Varaint_available == 'false'){
        $(".quick-buy__addTo").addClass("disabled");
    }
    else{
    $(".quick-buy__addTo").removeClass("disabled");
    }

    if(btn_price_type == 'one-time'){
        $('.main-product__atc span').text(product_price);
        $('.main-product__atc del').text(product_comp_price);
    }else{
        $('.main-product__atc span').text(product_sub_price);
        $('.main-product__atc del').text(product_comp_price);
    }
}



function selectVariantType(){
    // $('.variant-select').on("change",function(){
    var product_price = $('.variant-select option:checked').attr('data-price');
    var product_sub_price = $('.variant-select option:checked').attr('data-sub-price');
    var product_comp_price = $('.main-product__input:checked').attr('data-comp-price');
    $('.subscriptions__one-time .subscriptions__right').text(product_price);
    $('.sub-price').text(product_sub_price);
    $('.origin-price').text(product_price);
    if(btn_price_type == 'one-time'){
        $('.main-product__atc span').text(product_price);
        $('.main-product__atc del').text(product_comp_price);
    }else{
        $('.main-product__atc span').text(product_sub_price);
        $('.main-product__atc del').text(product_comp_price);
    }
// });
}





function addTocart(event){
    event.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.quick-buy-product-form').serialize(),
          success: function(data) {
            get_cart_details();
            $('.cart-wrap').css('transform', 'translateY(0%)');
            $('body').removeClass('quick-buy-popup-open');
          },
          error: 'addToCartFail'
      });
      
 

}


var btn_price_type = 'subscription';
var btn_price = $('.main-product__input:checked').attr('data-sub-price');

// function sellingPlan(el){

//    $('.selling-plan').removeClass('active');
//     $(el).addClass('active');
//     $(el).find('.subscriptions__input').prop("checked", true);
//     $('.subscriptions__input').trigger("change");
//     btn_price_type = $(el).attr('selling_type');
//     btn_price = $('.subscriptions__input:checked').parent().find('.da-price').text();
//     console.log(btn_price);
//     console.log(btn_price);
//     $('.main-product__atc span').text(btn_price);

//     var selling_plan_trace = $('.subscriptions__input:checked').attr('value');
//     if(selling_plan_trace == 'subscribe'){
//         $('.subscriptions__select').attr('name', 'selling_plan');
//         console.log("subs")
//     }else{
//         $('.subscriptions__select').attr('name', '');
//          console.log("not")
//     } 
// }

function sellingPlan(el) {
  $('.selling-plan').removeClass('active');
  $(el).addClass('active');
  $(el).find('.subscriptions__input').prop("checked", true);
  $('.subscriptions__input').trigger("change");

  let btn_price_type = $(el).attr('selling_type');
  let btn_price = $('.subscriptions__input:checked').parent().find('.da-price').text();
  $('.main-product__atc span').text(btn_price);

  let selling_plan_trace = $('.subscriptions__input:checked').val();

  if (selling_plan_trace === 'subscribe') {
    // Behavior of subscriptionOption
    $(".subscriptions__one-time").removeClass("active");
    $(el).addClass("active");
    $('.subscriptions__bot').slideDown();
    $('.subscriptions__text').removeClass('strike-through');
    $('.sub-timeline').slideDown();
    $('.subscriptions__select').attr('name', 'selling_plan');
    $('.one-time-feeding-guide-btn').slideUp();
    $('.sub-trusted-text').slideDown();
    console.log("subs");
  } else {
    // Behavior of oneTime
    $('.subscriptions__bot').slideUp();
    $(".subscriptions__subscribe").removeClass("active");
    $('.sub-timeline').slideUp();
    $(el).addClass("active");
    $('.subscriptions__select').attr('name', '');
    $('.subscriptions__text').addClass('strike-through');
    $('.one-time-feeding-guide-btn').slideDown();
    $('.sub-trusted-text').slideUp();
    console.log("not");
  }
}




$(document).ready(function () {
    const $tabs = $('.collection__tabs-btn');
    const $itemsContainer = $(".collection__items");

    function cardLoad(handle) {
        fetch(handle + "?section_id=collection-card")
        .then((response) => response.text())
        .then((data) => {
            var render_html = $(data);
            var collection_html = $(".collection__items", render_html);
            $(".collection__items").replaceWith(collection_html);
        });
    }

    function update_collection(handle){
        fetch(handle + "?section_id=main-collection")
        .then((response) => response.text())
        .then((data) => {
            var render_html = $(data);
            var collection_html = $(".collection__headding", render_html);
            $(".collection__headding").replaceWith(collection_html);
            // var collection_html = $(".collection__headding", render_html);
            // $(".collection__headding").replaceWith(collection_html);
        });
    }

    function updateURLPath(handle) {
        const newPath = `${handle}`;
        window.history.pushState({}, '', newPath); 
    }

    // On tab click
    $tabs.on('click', function (e) {
        e.preventDefault();
        const handle = $(this).attr('data-tab');

        // Update active class
        $tabs.removeClass('active');
        $(this).addClass('active');

        // Update URL path
        updateURLPath(handle);

        // Load collection content
        cardLoad(handle);
        update_collection(handle);
    });

    // On page load: auto-load correct tab if not already active
    const currentPath = window.location.pathname;
    const collectionHandle = currentPath.split('/collections/')[1];

    if (collectionHandle) {
        const $matchedTab = $tabs.filter(`[data-tab="${currentPath}"]`);
        if ($matchedTab.length) {
            $tabs.removeClass('active');
            $matchedTab.addClass('active');
            cardLoad(currentPath);
            // update_collection(currentPath);
        }
    }
});



function openQuantity(event,el){
   event.stopPropagation();
    $(el).next().slideToggle();
 
}
function QuantityOption(el){
    $(el).slideUp();
 
}



// // custom new js end here 

































$(".main-product__img-items").slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
});

// Pause the outgoing slide's video when the carousel slides
$(".main-product__img-items").on("beforeChange", function (event, slick, currentSlide) {
    var $outgoing = $(slick.$slides[currentSlide]);
    $outgoing.find("video.main-product__video-el").each(function () {
        this.pause();
        $(this).closest(".main-product__video").find(".video-play-btn").removeClass("is-hidden");
    });
    $outgoing.find(".main-product__video--external iframe").each(function () {
        var src = $(this).attr("src");
        $(this).attr("src", "").attr("src", src);
    });
});

// Play any autoplay video on the incoming slide
$(".main-product__img-items").on("afterChange", function (event, slick, currentSlide) {
    var $incoming = $(slick.$slides[currentSlide]);
    $incoming.find("video.main-product__video-el[autoplay]").each(function () {
        var video = this;
        video.play().catch(function () {});
    });
});

// Video play button overlay
(function () {
    function initVideoPlayButtons() {
        document.querySelectorAll(".main-product__video").forEach(function (wrapper) {
            var video = wrapper.querySelector("video.main-product__video-el");
            var btn = wrapper.querySelector(".video-play-btn");

            if (video && video.hasAttribute("autoplay")) {
                video.play().catch(function () {});
            }

            if (!video || !btn) return;

            btn.addEventListener("click", function () {
                video.play();
            });

            video.addEventListener("click", function () {
                if (video.paused) {
                    video.play();
                } else {
                    video.pause();
                }
            });

            video.addEventListener("play", function () {
                btn.classList.add("is-hidden");
            });

            video.addEventListener("pause", function () {
                btn.classList.remove("is-hidden");
            });

            video.addEventListener("ended", function () {
                btn.classList.remove("is-hidden");
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initVideoPlayButtons);
    } else {
        initVideoPlayButtons();
    }
})();

// Image zoom lightbox
(function () {
    var overlay = document.getElementById("mediaZoomOverlay");
    var zoomImg = document.getElementById("mediaZoomImg");
    var closeBtn = document.getElementById("mediaZoomClose");
    if (!overlay) return;

    $(document).on("click", ".main-product__img--zoomable img", function () {
        var src = $(this).data("zoom") || $(this).attr("src");
        var alt = $(this).attr("alt") || "";
        zoomImg.src = src;
        zoomImg.alt = alt;
        overlay.classList.add("is-active");
        document.body.style.overflow = "hidden";
    });

    function closeZoom() {
        overlay.classList.remove("is-active");
        document.body.style.overflow = "";
        zoomImg.src = "";
    }

    closeBtn.addEventListener("click", closeZoom);

    overlay.addEventListener("click", function (e) {
        if (e.target === overlay) closeZoom();
    });

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && overlay.classList.contains("is-active")) closeZoom();
    });
})();


// faq start

$(".faq__dropdown-item-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".faq__dropdown-item-content").slideUp();
    } else {
        $(".faq__dropdown-item-content").slideUp();
        $(".faq__dropdown-item-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".faq__dropdown-item-content").slideDown();
    }
})


// faq end




// $(document).ready(function () {
//     $('.poops__checked').each(function () {
//         $(this).prop('checked', true);
//         $(this).on('click', function (event) {
//             event.preventDefault();
//             $(this).prop('checked', true);
//         });
//     });
// });



$('.product-accordion__items').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false
        }
    }]
});

$('.product-accordion__arrow_left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product-accordion__arrow_right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

$('.product-accordion__items').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
        $('.product-accordion__arrow_left').addClass('hidden');
    } else {
        $('.product-accordion__arrow_left').removeClass('hidden');
    }
    if (currentSlide === slick.slideCount - 3) {
        $('.product-accordion__arrow_right').addClass('hidden');
    } else {
        $('.product-accordion__arrow_right').removeClass('hidden');
    }
});


$('.product-accordion__title').on("click",function(){
    $(this).toggleClass("active");
    $(this).next(".product-accordion__content-wrap").slideToggle();
    if ($(this).hasClass('active')) {
        // $(this).removeClass("active");
        // $(this).next(".product-accordion__content-wrap").slideUp();
    } else {
        // $(".product-accordion__content-wrap").slideUp();
        // $(".product-accordion__title").removeClass("active");

        // $('html, body').animate({
        //     scrollTop: $(this).parent().offset().top
        // }, 1000);
        // $(this).toggleClass("active");
        // $(this).next(".product-accordion__content-wrap").slideToggle();
    }
});





var btn_price_type = 'subscription';
var btn_price = $('.main-product__input:checked').attr('data-sub-price');
$('.selling-plan').on("click",function(){
    $('.selling-plan').removeClass('active');
    $(this).addClass('active');
    $(this).find('.subscriptions__input').prop("checked", true);
    $('.subscriptions__input').trigger("change");
    btn_price_type = $(this).attr('selling_type');
    btn_price = $('.subscriptions__input:checked').parent().find('.da-price').text();
    console.log(btn_price);
    $('.main-product__atc span').text(btn_price);

    var selling_plan_trace = $('.subscriptions__input:checked').attr('value');
    if(selling_plan_trace == 'subscribe'){
        $('.subscriptions__select').attr('name', 'selling_plan');
    }else{
        $('.subscriptions__select').attr('name', '');
    }
});






$('.main-product__input').on("change",function(){
    var thisProd = $(this).parents('form');
    var product_price = thisProd.find('.main-product__input:checked').attr('data-price');
    var product_sub_price = thisProd.find('.main-product__input:checked').attr('data-sub-price');
    var product_comp_price = thisProd.find('.main-product__input:checked').attr('data-comp-price');
     var Varaint_available= thisProd.find(".main-product__input:checked").attr("data-varinat-available");
console.log("$('.main-product__input').on", Varaint_available);
    if(Varaint_available == 'false'){
        $(".main-product__atc").addClass("disabled");
    }
    else{
        $(".main-product__atc").removeClass("disabled");
    }

    $('.subscriptions__one-time .subscriptions__right').text(product_price);
    $('.sub-price').text(product_sub_price);
    $('.origin-price').text(product_price);
    if(btn_price_type == 'one-time'){
        $('.main-product__atc span').text(product_price);
        $('.main-product__atc del').text(product_comp_price);
    }else{
        $('.main-product__atc span').text(product_sub_price);
        $('.main-product__atc del').text(product_comp_price);
    }
});


$('.variant-select').on("change",function(){
    var thisProd = $(this).parents('form');
    var product_price = thisProd.find('.variant-select option:checked').attr('data-price');
    var product_sub_price = thisProd.find('.variant-select option:checked').attr('data-sub-price');
    var product_comp_price = thisProd.find('.main-product__input:checked').attr('data-comp-price');
    $('.subscriptions__one-time .subscriptions__right').text(product_price);
    $('.sub-price').text(product_sub_price);
    $('.origin-price').text(product_price);


   var Varaint_available= thisProd.find(".variant-select option:checked").attr("data-varinat-available");
   console.log("$('.variant-select').on",Varaint_available);
    if(Varaint_available == 'false'){
        $(".main-product__atc").addClass("disabled");
    }
    else{
    $(".main-product__atc").removeClass("disabled");
    }


    if(btn_price_type == 'one-time'){
        $('.main-product__atc span').text(product_price);
        $('.main-product__atc del').text(product_comp_price);
    }else{
        $('.main-product__atc span').text(product_sub_price);
        $('.main-product__atc del').text(product_comp_price);
    }
});

$('.subscriptions__one-time').on("click",function(){
    $('.subscriptions__bot').slideUp();
    $('.subscriptions__text').addClass('strike-through');
    $('.sub-timeline').slideUp();
    $('.one-time-feeding-guide-btn').slideDown();
    $('.sub-trusted-text').slideUp();
})
$('.subscriptions__subscribe').on("click",function(){
    $('.subscriptions__bot').slideDown();
    $('.subscriptions__text').removeClass('strike-through');
    $('.sub-timeline').slideDown();
    $('.one-time-feeding-guide-btn').slideUp();
    $('.sub-trusted-text').slideDown();
})





$( ".main-product__atc_single").on("click", function (e) {
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.single-product-form').serialize(),
          success: function(data) {
            get_cart_details();
            // $('body').addClass('cart-modal-open');
            $('.cart-wrap').css('transform', 'translateY(0%)');
          },
          error: 'addToCartFail'
      });
      
  });



  
  $(document).ready(function() {
    $(".poops__select-item-input_1").change(function() {
      if ($(this).is(':checked')) {
        $('.bundle-form-input-1').attr('name', 'id[]');
      } else {
        $('.bundle-form-input-1').removeAttr('name');
      }
      bundleTotalPrice()
    });
  });

  $(document).ready(function() {
    $(".poops__select-item-input_2").change(function() {
      if ($(this).is(':checked')) {
        $('.bundle-form-input-2').attr('name', 'id[]');
      } else {
        $('.bundle-form-input-2').removeAttr('name');
      }
      bundleTotalPrice()
    });
  });


function bundleTotalPrice() {
    var bundlePrice = 0;
    var itemPrice = 0;
  $(".bundle-input:checked").each(function() {
        itemPrice = parseFloat($(this).attr('data-price'));
        bundlePrice = bundlePrice + itemPrice;
        // console.log($(this).attr('data-price'));
        
    })
    bundlePrice = parseFloat(bundlePrice);
    // console.log(bundlePrice);
    $(".poops__bottom-btn span").text(bundlePrice.toFixed(2));
}

function defaultPriceShow(){
    bundlePrice = 0
    itemPriceFirst = parseFloat($('.poops__select-item-input_1').attr('data-price'));
    itemPriceSecond = parseFloat($('.poops__select-item-input_2').attr('data-price'));        
        bundlePrice = itemPriceFirst + itemPriceSecond;
        $(".poops__bottom-btn span").text(bundlePrice.toFixed(2));
}
defaultPriceShow()



//   let totalPrice = 0;
//   $(".poops__select-item-input").change(function() {
//     $(".poops__select-item-input:checked").each(function() {
//         totalPrice += parseInt($(this).attr("data-price"));
//         console.log(totalPrice);
//         $(".poops__bottom-btn span").text(totalPrice);
        
//     })
//   })
  


$(document).on('click', '.upsell_atc-btn', function (e) {
    e.preventDefault();
    $(this).addClass('loading');
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).parent().find('.cart_upsell').serialize(),
          success: function(data) {
            get_cart_details();
            // $('body').addClass('cart-modal-open');
            $( ".upsell_atc-btn").removeClass('loading');
            $('.cart-wrap').css('transform', 'translateY(0%)');
          },
          error: 'addToCartFail'
      });
  });


  $( ".poops__bottom-btn").on("click",  function (e) {
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.bundle-form').serialize(),
          success: function(data) {
            get_cart_details();
            // $('body').addClass('cart-modal-open');
            $('.cart-wrap').css('transform', 'translateY(0%)');
          },
          error: 'addToCartFail'
      });
      
  });

  //   Add
function get_cart_details(){
    fetch("?section_id=mini-cart")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        var cart_items = $(".cart-left", cart_html);
        $(".cart-left").replaceWith(cart_items);
        var cart_upsell_items = $(".upsell-item-outer", cart_html);
        $(".upsell-item-outer").replaceWith(cart_upsell_items);
      });
  
      fetch("?section_id=header")
      .then((response) => response.text())
      .then((headerData) => {
        var cart_html = $(headerData);
        var cart_count = $(".cart span", cart_html);
        var cart_count_text = $(cart_count).text();
        $(".cart span").text(cart_count_text);
        $('.cart-title span').replaceWith(cart_count);
      });

  $('.mobi-fixed-checkout').css('transform', 'translateY(0%)');
      
  
  };



  // Increase and decrease
function increaseC(el) {
    var $input = el.previousElementSibling;
    var value = parseInt($input.value);
    value = isNaN(value) ? 0 : value
    value++;
    $input.value = value;      
    change_qty($input);

  }
  
  function decreaseC(el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value);
    if (value > 0) {
        value = isNaN(value) ? 0 : value;
        value--;
        $input.value = value;  
        change_qty($input);
    }
  }
  function change_qty(input) {

    var quantity = $(input).val();
    var data_line = $(input).attr("data-line");
    
    // Validate that we have the line item key
    if (!data_line) {
      console.error("Error: data-line attribute not found on input");
      return;
    }
    
    var data = {
      "id": data_line,
      "quantity": quantity
    };
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: data,
      success: function (data) {
        console.log(data);
        get_cart_details(); 
      },
      error: function (err) {
        console.error("Error from quantity update:", err);
      }
    })
  
  
  }

  //   Remove
// remove item form cart
function itemRemove(e, el) {
    e.preventDefault();
    var data_line = $(el).attr("data-line");
    
    // Validate that we have the line item key
    if (!data_line) {
      console.error("Error: data-line attribute not found on remove button");
      return;
    }
    
    var data = {
        "id": data_line,
        "quantity": 0
    }
    $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
        success: function (data) {
            get_cart_details()
        },
        error: function (err) {
            console.error("Error removing item:", err);
        }
    })
}







var lastScrollTop = 0;
$(window).scroll(function (event) {
    var scroll = $(this).scrollTop();
    if (scroll > lastScrollTop) {
        if (scroll >= 1300) {
            $("body").addClass("atc-fixed");
        } else {
            $("body").removeClass("atc-fixed");
        };
    } else {
        if (scroll >= 1300) {
        } else {
            $("body").removeClass("atc-fixed");
        }
    }
    lastScrollTop = scroll;
});


// review slider
if ($(window).width() < 768) {
$('.review__items').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: false
        }
    }]
});
}

$('.review__arrow_left').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.review__arrow_right').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});





$(document).ready(function() {   
    $(".review__item-wrap").slice(0, 3).show();
    $(".review__more_desk").click(function() {
        $(".review__item-wrap:hidden").slice(0, 3).slideDown();
        if ($(".review__item-wrap:hidden").length === 0) {
          $(this).hide();
        }
    });
  });


  $('.custom-dropdown__stat').click(function (e) {
    e.stopPropagation();
    $(this).next().slideToggle();
  });

  $(document).click(function () {
    $('.custom-dropdown__items').slideUp();
  });
  $('.custom-dropdown__item').click(function () {
    var text = $(this).html();
    var item_price = $(this).attr('data-price');
    $('.custom-dropdown__stat').html(text);
    // $('.variant-select option [value="' + item + '"]').prop('selected', true);
    $('.variant-select option').attr("selected", false);
    $('.variant-select [data-price="' + item_price + '"]').attr("selected", true);
    $('.variant-select').trigger('change');
  });

  // gallery start


// $('.gallery__items').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     arrows: false,
//     responsive: [{
//         breakpoint: 768,
//         settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1
//         }
//     }, ]
// });


// $('.gallery__right-arrow').click(function () {
//     $(this).parent().parent().find('.slick-slider').slick('slickNext');
// });


// // gallery end
